



































import { Component, Vue, Ref, Watch } from "vue-property-decorator";
@Component({
  name: "navdraw"
})
export default class navdraw extends Vue {
  logoPath: any = require("../assets/img/logo.jpg");

  links: any[] = [
    { icon: "mdi-home", text: "Startseite", route: "/" },
    { icon: "mdi-image-filter", text: "Referenzen", route: "/reference" },
    { icon: "mdi-image-filter", text: "Impressum", route: "/about" }
  ];
  get drawer() {
    return this.$store.getters["getNavbarState"];
  }
  set drawer(val) {
    this.$store.commit("setDrawer", val);
  }
}
